import Config from "../config/config";
import axios from "axios";
import * as CryptoJs from "crypto-js";

export const getCookie = (cookieName) => {
  let name = cookieName + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const isEmpty = (value) =>
  value === undefined ||
  value == "undefined" ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0) ||
  (typeof value === "string" && value === "0") ||
  (typeof value === "number" && value === 0);

export const NumberChange = (data) => {
  try {
    return isNaN(Number(data)) ? 0 : Number(data);
  } catch (err) {
    console.log("NumberChange_error", err);
    return 0;
  }
};

export const NumberOnly = (data) => {
  return data.toString().replace(Config.NumOnly, "");
};

export const GetToken = (key) => {
  if (key) {
    let cookie = ("; " + document.cookie)
      .split(`; ${key}=`)
      .pop()
      .split(";")[0];
    return cookie;
  } else {
    return undefined;
  }
};

export const SetToken = (tokenkey, token) => {
  if (tokenkey && token) {
    document.cookie = `${tokenkey}= ${token}`;
  }
  return true;
};

export const deleteToken = (tokenkey) => {
  if (tokenkey) {
    document.cookie = `${tokenkey}= ; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
  return undefined;
};

export const axiosFunc = async (data, token) => {
  try {
    let Resp = {};

    let type = "application/json"
    if (data?.params) {
      data.params = { data: EncryptData(data.params) };
    } else if (data?.data) {
      console.log('kdjgsfgdsf', containsFiles(data?.data))
      if (containsFiles(data?.data)) {
        type = "multipart/form-data"
        let encData = await AppenData(data?.data)
        data.data = encData[0]
      }
      else if (!(data?.data instanceof FormData)) {
        data.data = { data: EncryptData(data.data) };
      }
    }
    if (data?.headers) {
      console.log("dsdsfs", containsFiles(data?.data))
      data.headers["Content-Type"] = type
      data.headers.Authorization =
        "Bearer " + (token ?? GetToken(Config.adminCookieName));
    } else {
      let headers = {}
      headers = {
        "Content-Type": type,
        Authorization: "Bearer " + (token ?? GetToken(Config.adminCookieName)),
      };

      data.headers = headers
    }
    // if(false){
    // if (data?.params) {
    //   data.params = { data: EncryptData(data.params) };
    // } else if (data?.data) {
    //   if (!(data?.data instanceof FormData)) {
    //     data.data = { data: EncryptData(data.data) };
    //   }
    // }
    // if (data?.headers) {
    //   data.headers.Authorization =
    //     "Bearer " + (token ?? GetToken(Config.userCookieName));
    // } else {
    //   data.headers = {
    //     Authorization: "Bearer " + (token ?? GetToken(Config.userCookieName)),
    //   };
    // }
    // }
    Resp = await axios(data);
    if (Resp?.data) {
      Resp.data =
        typeof DecryptData(Resp.data) == "string" &&
          DecryptData(Resp.data) == ""
          ? Resp.data
          : DecryptData(Resp.data);
    }
    if (data?.url?.includes("/getUserCollection")) {
      console.log("mdshfshfsfsfafa", Resp, DecryptData(Resp.data));
    }

    return Resp;
  } catch (e) {
    return { success: "error", msg: null };
  }
};

// export const AppenData = (data) => {
//   var formdata = new FormData();
//   var SendDta = Object.entries(data).map((item) => {
//     if (Array.isArray(item[1])) {
//       var come = item[1].map((data) => {
//         if (data?.type && data?.size) {
//           //file
//           formdata.append(item[0], data);
//         } else {
//           formdata.append(item[0], EncryptData(data));
//         }
//         return formdata;
//       });
//       return come;
//     } else {
//       if (item[1]?.type && item[1]?.size) {
//         //file type
//         formdata.append(item[0], item[1]);
//       } else {
//         formdata.append(item[0], EncryptData(item[1]));
//       }
//       return formdata;
//     }
//   });
//   console.log("dkshfsfsfkjshf", SendDta, formdata);
//   return [formdata];
// };
export const AppenData = (data) => {
  var formdata = new FormData();
  var SendDta = Object.entries(data).map((item) => {
    console.log('item-->', item)
    if (Array.isArray(item[1])) {
      var come = item[1].map((data) => {
        if (data?.type && data?.size) {
          //file
          formdata.append(item[0], data);
        } else {
          formdata.append(item[0], EncryptData(data));
        }
        return formdata;
      });
      return come;
    } else if (containsFiles(item[1])) {
      let file = Object.values(item[1]).filter(val => val instanceof File);
      let name = Object.keys(item[1]).filter(val => item[1][val] instanceof File);
      formdata.append(name ?? item[0], file[0]);
      formdata.append(item[0], EncryptData(item[1]));
    } else {
      if (item[1]?.type && item[1]?.size) {
        //file type
        formdata.append(item[0], item[1]);
      } else {
        console.log(item[0], ":", EncryptData(item[1]))
        formdata.append(item[0], EncryptData(item[1]));
      }
      return formdata;
    }
  });
  console.log(formdata.get("lpToken"))
  return [formdata];
};

function containsFiles(obj) {
  return Object.values(obj).some(val => {
    if (val instanceof File || val instanceof Blob) {
      return true;
    }
    if (typeof val === 'object' && val !== null) {
      return containsFiles(val); // Recursive check
    }
    return false;
  });
}

export const EncryptData = (data) => {
  if (typeof data == "string") {
    return CryptoJs.AES.encrypt(data, Config.KEY).toString();
  } else {
    return CryptoJs.AES.encrypt(JSON.stringify(data), Config.KEY).toString();
  }
};

export const DecryptData = (data) => {
  try {
    var bytes = CryptoJs.AES.decrypt(data, Config.KEY);

    var decryptedData;
    try {
      decryptedData = JSON.parse(bytes.toString(CryptoJs.enc.Utf8));
    } catch (err) {
      try {
        decryptedData = bytes.toString(CryptoJs.enc.Utf8);
      } catch (dcpterr) {
        return "";
      }
    }
    return decryptedData;
  } catch (error) {
    return "";
  }
};

export const formatNumber = (number) => {
  return Number(number).toLocaleString("en-US", {
    // add suffixes for thousands, millions, and billions
    // the maximum number of decimal places to use
    maximumFractionDigits: 2,
    // specify the abbreviations to use for the suffixes
    notation: "compact",
    compactDisplay: "short",
  });
};

export const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};


export const getAddItemFieldMap = (exchangeLists) => {
  console.log("dewfrcewfvvvg", exchangeLists);

  const map = {};
  exchangeLists?.forEach(step => {
    step?.fields?.forEach(field => {
      if (field?.additem) {
        if (!map[step.stepName]) map[step.stepName] = [];
        map[step.stepName].push(field.name);
      }
    });
  });
  return map;
};

export const isValidEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

/* export const calculateCompletionPercentage = (formFields) => {
  console.log("setPercentage",formFields)
  let totalPoints = 0;
  let totalFields = 0;

  for (const [stepName, fields] of Object.entries(formFields || {})) {
    console.log("abbbbbb",fields)
    for (const [fieldName, value] of Object.entries(fields || {})) {
    console.log("sssvalue",value)

      totalFields += 1;

      const isNonEmptyString = typeof value === "string" && value.trim() !== "";
      const isNonEmptyArray = Array.isArray(value) && value.length > 0 && value.some(v => v && v.trim?.() !== "");
      const isValidDate = value instanceof Date && !isNaN(value);
      const isFile = typeof File !== "undefined" && value instanceof File;
      const isNonEmptyObject = typeof value === "object" && value !== null && !Array.isArray(value) && !(value instanceof File) && Object.keys(value).length > 0;
      const isTrueBoolean = typeof value === "boolean" && value === true;

      if (
        isNonEmptyString ||
        isNonEmptyArray ||
        isValidDate ||
        isFile ||
        isNonEmptyObject ||
        isTrueBoolean
      ) {
        totalPoints += 1;
      }
    }
  }

  const percentage = totalFields > 0 ? (totalPoints / totalFields) * 100 : 0;
  return {
    totalFields,
    totalPoints,
    percentageValue: +percentage.toFixed(2),
  };
}; */



export const calculateCompletionPercentage = (formFields) => {
  console.log("derdddddddddddrr", formFields);

  let totalPoints = 0;
  let totalFields = 0;

  for (const [stepName, fields] of Object.entries(formFields || {})) {
    for (const [fieldName, value] of Object.entries(fields || {})) {
      console.log("valuevalue", value)
      totalFields += 1;

      const isNonEmptyString = typeof value === "string" && value.trim() !== "";

      const isNonEmptyArray = Array.isArray(value) && value.length > 0 && value.some(v =>
        (typeof v === "string" && v.trim() !== "") ||
        (typeof v === "object" && v !== null &&
          Object.values(v).some(val =>
            (typeof val === "string" && val.trim() !== "") ||
            (typeof val === "boolean" && val === true) ||
            (val instanceof Date && !isNaN(val))
          )
        )
      );

      const isValidDate = value instanceof Date && !isNaN(value);

      const isFile = typeof File !== "undefined" && value instanceof File;

      const isNonEmptyObject =
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value) &&
        !(value instanceof File) &&
        Object.values(value).some(val =>
          (typeof val === "string" && val.trim() !== "") ||
          (typeof val === "boolean" && val === true) ||
          (val instanceof Date && !isNaN(val))
        );

      const isTrueBoolean = typeof value === "boolean" && value === true;

      if (
        isNonEmptyString ||
        isNonEmptyArray ||
        isValidDate ||
        isFile ||
        isNonEmptyObject ||
        isTrueBoolean
      ) {
        totalPoints += 1;
      }
    }
  }

  const percentage = totalFields > 0 ? (totalPoints / totalFields) * 100 : 0;
  return {
    totalFields,
    totalPoints,
    percentageValue: +percentage.toFixed(2),
  };
};

export const formatDateMonYr =  (date) => {
  let dateformat = date?.split("-");
  const dateStr = `${dateformat[1] + "/" + dateformat[2] + "/" + dateformat[0]}`;
  console.log("dateStrdateStr", dateStr);
  return dateStr; // e.g. 05/07/2025
};
